// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__v_5DM","Title":"Header_Title__3D0bY"};